import { Article, CreateArticleInput } from "../../../api/schema";
import { FlexBox, FlexBoxInline } from "../../../components/flex/Flex";
import { InputModalBuilder } from "../../../components/form/InputModalBuilder";
import {
  InputFormMode,
  Mutation,
  ValuesVariables,
} from "../../../components/form/InputForm";
import { UserLanguage } from "../../../lang/lang";
import { ArticleListResponse, CreateArticleResponse } from "../helper/graphql";
import { CreateArticleModalKeys } from "./modals";

export type CreateArticleState = Article & { id?: string };

export interface CreateArticleModalProps {
  bundle: {
    open: boolean;
    onClose: () => void;
    onSuccess: (response: CreateArticleResponse) => void;
    mutation: Mutation<
      CreateArticleResponse,
      ValuesVariables<CreateArticleInput>
    >;
    article_view_data: ArticleListResponse | null;
  };
}

export const CreateArticleModal = (props: CreateArticleModalProps) => {
  return (
    <InputModalBuilder<Article, CreateArticleResponse, CreateArticleInput>
      {...props.bundle}
      keys={CreateArticleModalKeys(props.bundle.article_view_data)}
      texts={UserLanguage().pages.article.actions}
      open={props.bundle.open}
      reformId={["article_category", "footprint", "location", "product_group"]}
      mode={InputFormMode.Create}
      resetOnClose
      className="create_article_dialog"
    >
      {(builder) => (
        <FlexBox style={{ flexDirection: "column" }}>
          {builder.buildCards()}
          <FlexBoxInline style={{ gap: 15, justifyContent: "space-between" }}>
            {builder.buildField("matchcode")}
            {builder.buildField("display_name")}
          </FlexBoxInline>
          {builder.buildField("name")}
          {builder.buildField("footprint")}
          <FlexBoxInline style={{ gap: 15, justifyContent: "space-between" }}>
            {builder.buildField("article_category")}
            {builder.buildField("product_group")}
          </FlexBoxInline>
          <FlexBoxInline style={{ gap: 15, justifyContent: "space-between" }}>
            {builder.buildField("location")}
            {builder.buildField("inventory_type")}
          </FlexBoxInline>
          {builder.buildField("fields")}
          {builder.buildField("datasheet_url")}
          {builder.buildField("picture")}
          {builder.buildField("description")}
        </FlexBox>
      )}
    </InputModalBuilder>
  );
};
